import { AfterViewInit, Component, ViewChild } from "@angular/core";
import {
  NavController,
  Nav,
  NavParams,
  AlertController,
  ToastController,
  LoadingController,
  MenuController,
  ModalController,
  Events,
  Select
} from "ionic-angular";
import {
  User,
  LoginMyRadiant,
  RepositoryMyRadiant,
  NotificationProvider,
  HelperMyRadiant,
  FaskerProvider,
  NotesMyTeamProvider,
  Project,
  Master,
  Task,
  Notes,
  Dokumen
} from "@providers/index";
import { ForbidenloginComponent } from "../../../components/forbidenlogin/forbidenlogin";
import { NotifikasiPage } from "@pages/dashboard";

import { IonicImageLoader } from "ionic-image-loader";
import { DailyActivity, DetailNotesMyTeam, FilterProjectApps } from "@src/components/Content";
import { cmpFilterKaryawan } from "@src/components/filterKaryawan/cmp";
import { cmpMyOrganization } from "@src/components/myOrganization/cmp";
import { DetailImagePage, DetailTaskPage, FormTaskPage } from "..";

@Component({
  selector: "page-project-detail",
  templateUrl: "page.html"
})
export class ProjectDetailPage implements AfterViewInit {
  listTask: any;
  listNotes: any;
  listActivity: any = [];
  listSchedule: any = [];
  listInvoice: any = [];
  ngAfterViewInit(): void {
    // console.log('Super tabs is ', this.superTabs);
    // this.superTabs.selectTab(1);
  }

  // @ViewChild(SuperTabs) superTabs: SuperTabs;

  emp: any;
  img_url='';
  loading: any;
  selectedTabIndex = 0;
  btnTabProfilActive: string = "Detail";
  segmentActive: string = "general";
  stateRequest: any;
  // maxStateRequest = 12;

  parameter = {
    id: this.userApi.data.Employee_ID,
    user_code: this.userApi.data.NIK,
    nik: this.userApi.data.NIK,
    token: 1,
    user_nik: "",
    flag: "team"
  };

  data: any = {
    jml_notifikasi: this.notifikasiProvider.jmlNotifikasi,
    employee: "Me",
    department_selected: {
      fasker: "",
      advance: ""
    },
    expired: {
      mcu: "",
      insurance: ""
    },
    state_expired: {
      mcu: "",
      insurance: ""
    },
    presensi: {
      current: [],
      history: []
    },
    pegawai: {
      name: "-",
      idnumber: "-",
      division: "",
      company: "PT Radiant Utama Interisco",
      ttl: "-",
      religion: "-",
      grade: "-",
      pangkat: "-",
      jabatan: "-",
      startDate: "-",
      education: "-",
      leaveAmount: "-",
      leaveUsed: "-",
      leaveBalance: "-",
      address: "-"
    },
    general: {},
    family: [],
    asset: [],
    advance: {
      total: '200.000.000',
      list: [
        {
          name: '-',
          aging: 10, 
          amount: '50.000.000'
        },
        {
          name: '-',
          aging: 30, 
          amount: '50.000.000'
        },
        {
          name: '-',
          aging: 15, 
          amount: '50.000.000'
        },
        {
          name: '-',
          aging: 1, 
          amount: '50.000.000'
        }

      ]
    },
    finance:{
      summary: {},
      history:[
        {
          Bulan: 'April',
          Tahun: '2021',
          budget: '0.1%',
          actual: '0.2%',
        },
        {
          Bulan: 'Maret',
          Tahun: '2021',
          budget: '0.4%',
          actual: '0.2%',
        },
        {
          Bulan: 'Februari',
          Tahun: '2021',
          budget: '0.5%',
          actual: '0.2%',
        },
        {
          Bulan: 'Januari',
          Tahun: '2021',
          budget: '0.8%',
          actual: '0.2%',
        },
      ]
    },
    project: {
      active: [],
      last: []
    },
    total: {
      active_project: 0,
      active_ticket: 0,
      active_fi: 0,
      active_hotel: 0
    },
  };

  // PROJECT
  project: any = {};
  project_id = 0;
  project_code = '';
  akses: any = {};
  projek: any = {};
  global: any = {};

  //url sbp
  file_url1: any;
  file_url2: any;

  //akses
  can_edit = false;
  view_sbp = false;

  can_edit_task=false;
  view_sbp_task=false;

  can_delete_notes = false;

  hold_time_out: any;
  push_text = "";

  @ViewChild("filterKaryawan") selectRef: Select;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public userApi: User,
    public nav: Nav,
    public loginProvider: LoginMyRadiant,
    private menuCtrl: MenuController,
    public modalCtrl: ModalController,
    public repositoryMyRadiant: RepositoryMyRadiant,
    public notifikasiProvider: NotificationProvider,
    public events: Events,
    public helper: HelperMyRadiant,
    public faskerProvider: FaskerProvider,
    public notesProvider: NotesMyTeamProvider,
    public projectApi: Project,
    public masterApi: Master,
    public taskApi     : Task,
    public notesApi: Notes,
    public docApi: Dokumen,
  ) // public imgLoader     : IonicImageLoader,
  {
    this.akses = this.userApi.akses;

    if (this.navParams.get("project_id") != undefined) {
      this.project_id = this.navParams.get("project_id");
    }

    if (this.navParams.get("project_code") != undefined) {
      this.project_code = this.navParams.get("project_code");
    }

    this.img_url = this.docApi.file_url;
    this.file_url1 = "http://support.appsradiant.com/uploads/sbp/";
    // this.file_url2 = 'http://erp.appsradiant.com/app/api/index.php/show?Report_ID=RPT0256&kode_project=';
    this.file_url2 =
      "http://202.147.198.140/app/api/index.php/show?Report_ID=RPT0256&kode_project=";
    
      console.log(this.userApi);
      
      if(this.userApi.akses.edit_project_group_data=='branch'){
        if(this.project.branch_id == this.userApi.group.user_data){
          this.can_edit_task=true;
        }
      }else if(this.userApi.akses.edit_project_group_data=='all'){
        this.can_edit_task = true;
      }else if(this.userApi.akses.edit_project_group_data=='mine'){
        if(this.project.created_by == this.userApi.data.employee_id){
          this.can_edit_task=true;
        }
      }

      if (this.userApi.akses.delete_notes_project) {
        this.can_delete_notes = true;
      }
  }

  samarkan(v) {
    console.log(v);
    let val = v;
    val = parseFloat(val);
    val = val / 1000000;
    val = val.toFixed(1);
    console.log(val);
    if (val == "NaN") {
      val = "-";
    }
    return val;
  }


  ionViewDidEnter() {
    this.getLanguage();
    if (this.project_id > 0) {
      this.getList();
      this.getTask();
      this.getNotes();
    }
    if (this.project_code != '') {
      // this.getAdvance();
    }

    this.check_permission();
  }

  check_permission() {
    if (this.userApi.akses.edit_project_group_data == "branch") {
      if (
        this.project.branch_id == this.userApi.group.user_data ||
        this.project.branch_id == this.userApi.data.hrm_company_office_id
      ) {
        this.can_edit = true;
      }
    } else if (this.userApi.akses.edit_project_group_data == "all") {
      this.can_edit = true;
    } else if (this.userApi.akses.edit_project_group_data == "mine") {
      if (this.project.created_by == this.userApi.data.employee_id) {
        this.can_edit = true;
      }
    }
    console.log(this.userApi);
    //set akses view Usage Budget & Project Budget
    if (this.userApi.akses.view_budget) {
      this.view_sbp = true;
    }

    console.log("akses => ", this.userApi.akses);
  }

  getLanguage() {
    this.masterApi.language().subscribe((resp: any) => {
      this.global = resp.global;
      this.projek = resp.project;
    });
  }

  getList() {
    let loading = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loading.present();
    let params: any = {
      project_id: this.project_id
    };
    this.projectApi.get(params).subscribe(
      (resp: any) => {
        this.project = resp.data[0];
        loading.dismiss();
      },
      err => {
        loading.dismiss();
      }
    );
  }

  // START TASK

  getTask(){
    let loading = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loading.present();
    let params = {
      project_id : this.project_id
    }
    this.taskApi.get(params).subscribe((resp:any) => {
      this.listTask = resp.data;
      loading.dismiss();
    });
  }

  addTask(){
    this.navCtrl.push(FormTaskPage, {
      project : this.project
    })
  }

  editTask(rec) {
    this.navCtrl.push(FormTaskPage, {
      project: this.project,
      rec:rec
    });
  }

  detailTask(rec) {
    this.navCtrl.push(DetailTaskPage, {
      project: this.project,
      rec:rec
    });
  }


  // END TASK

  // START NOTES

  getNotes(){
    let loading = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loading.present();
    let params = {
      project_id: this.project_id
    }
    this.notesApi.get(params).subscribe((resp:any) => {
      this.listNotes = resp.data;
      loading.dismiss();
    });
  }

  addNotes(){
    this.navCtrl.push(FormTaskPage, {
      project : this.project
    })
  }

  editNotes(rec) {
    this.navCtrl.push(FormTaskPage, {
      project: this.project,
      rec:rec
    });
  }

  detailNotes(rec) {
    this.navCtrl.push(DetailTaskPage, {
      project: this.project,
      rec:rec
    });
  }

  detailImage(rec : any = {}){
    let detailModal = this.modalCtrl.create(DetailImagePage,{
      url_image : this.img_url+rec.generated_name,
      detail : rec
    });
    detailModal.present();
  }


  // END NOTES

  filterKaryawan() {
    let me = this;
    this.showLoading();
    let params = {
      id: this.userApi.data.Employee_ID,
      active_tab: this.btnTabProfilActive
    };
    this.repositoryMyRadiant.checkBeforeGetBawahan(params).subscribe(
      (resp: any) => {
        try {
          this.loading.dismiss();
        } catch (error) {}
        if (resp.success) {
          let karyawanModal = this.modalCtrl.create(
            cmpFilterKaryawan,
            {
              active_tab: params.active_tab,
              karyawan: resp.data.list,
              isAddHoc: resp.data.isAddHoc,
              fiturSearching: true,
              title: "My Team Profile",
              level: resp.data.level
            },
            { cssClass: "select-modal", enableBackdropDismiss: false }
          );
          karyawanModal.onDidDismiss(karyawan => {
            if (karyawan) {
              if (karyawan == "me") {
                me.data.employee = "Me";
                me.parameter.nik = this.userApi.data.NIK;
                me.parameter.user_code = this.userApi.data.NIK;
                me.parameter.id = this.userApi.data.Employee_ID;
                me.data.department_selected.fasker = "";
                me.data.department_selected.advance = "";
                me.parameter.flag = "team";
              } else {
                me.data.employee = karyawan.name;
                me.parameter.nik = karyawan.nik;
                me.parameter.user_code = karyawan.nik;
                me.parameter.id = karyawan.id;
                me.data.department_selected.fasker = "";
                me.data.department_selected.advance = "";
                me.parameter.flag = "team";
              }
              // this.showLoading();
              
            }
          });
          karyawanModal.present();
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  onTabSelect(ev: any) {
    this.selectedTabIndex = ev.index;
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: "Please wait..."
    });
    this.loading.present();
  }

  presentToast(msg) {
    this.toastCtrl
      .create({
        message: msg,
        duration: 3000,
        position: "top"
      })
      .present();
  }

  changeTabProfil(evt, tab) {
    this.btnTabProfilActive = tab;
    localStorage.setItem("tabActiveProfile", tab);
  }

  expandSegment(evt, segment): void {
    this.segmentActive = segment;
  }
  collapseSegment(evt, segment) {
    this.segmentActive = "none";
  }

  getGeneral() {
    let me = this;
    this.repositoryMyRadiant.getProfilGeneral(this.parameter).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.success) {
          me.data.pegawai.name = resp.data.name;
          me.data.pegawai.idnumber = resp.data.code;
          me.data.pegawai.jabatan = resp.data.position_name;
          me.data.pegawai.division = resp.data.division_name;
          me.data.pegawai.img = resp.data.img;

          me.data.general = resp.data;
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  getAssets() {
    let me = this;
    this.repositoryMyRadiant.getProfilAssets(this.parameter).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.success) {
          me.data.asset = resp.data;
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  getAdvance() {
    let me = this;
    this.projectApi.getListAdvance({
      project_code: this.project_code
    }).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.success) {
          // me.data.advance.total = resp.total_amount != null ? resp.total_amount.total_amount : 0;
          me.data.advance.total = resp.totalAmount;
          me.data.advance.list = resp.data;
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  getProject() {
    let me = this;
    this.repositoryMyRadiant.getProfilProject(this.parameter).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.active.success) {
          me.data.total.active_project = resp.active.data.length;
          me.data.project.active = resp.active.data;
        }
        if (resp.last.success) {
          me.data.project.last = resp.last.data;
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  getFamily() {
    let me = this;
    this.repositoryMyRadiant.getProfilFamily(this.parameter).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.success) {
          me.data.family = resp.data;
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  getMedical() {
    let me = this;
    this.repositoryMyRadiant.getProfilMedical(this.parameter).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.success) {
          me.data.medical = resp.data;
          me.data.expired.mcu = resp.expired_date;
          me.data.state_expired.mcu = resp.state_expired;
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  getInsurance() {
    let me = this;
    this.repositoryMyRadiant.getProfilInsurance(this.parameter).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.success) {
          me.data.insurance = resp.data;
          me.data.expired.insurance = resp.expired_date;
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  getCeritificate() {
    let me = this;
    this.repositoryMyRadiant.getProfilCeritificate(this.parameter).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.success) {
          me.data.certificate = resp.data;
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  getTicket() {
    let me = this;
    this.repositoryMyRadiant.getProfilTicket(this.parameter).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.success) {
          me.data.total.active_ticket = 0;
          me.data.ticket.active = [];
          me.data.ticket.last = [];
          resp.data.forEach(row => {
            if (row.flag == "current") {
              me.data.total.active_ticket = me.data.total.active_ticket + 1;
              me.data.ticket.active.push(row);
            }
            if (row.flag == "last") {
              me.data.ticket.last.push(row);
            }
          });
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  getPresensi() {
    let me = this;
    this.repositoryMyRadiant.getProfilPresensi(this.parameter).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.success) {
          me.data.presensi.current = [];
          me.data.presensi.history = [];
          resp.data.records.forEach(row => {
            if (row.flag_data == "current") {
              if (row.state_font == "black") {
                row.state_font = "green";
              }
              me.data.presensi.current.push(row);
            } else {
              me.data.presensi.history.push(row);
            }
          });
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  getHotel() {
    let me = this;
    this.repositoryMyRadiant.getProfilHotel(this.parameter).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.success) {
          me.data.total.active_hotel = 0;
          me.data.hotel.active = [];
          me.data.hotel.last = [];
          resp.data.forEach(row => {
            if (row.flag == "current") {
              me.data.total.active_hotel = me.data.total.active_hotel + 1;
              me.data.hotel.active.push(row);
            }
            if (row.flag == "last") {
              me.data.hotel.last.push(row);
            }
          });
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  getInstruction() {
    let me = this;
    this.repositoryMyRadiant.getProfilFI(this.parameter).subscribe(
      (resp: any) => {
        this.stateRequest = this.stateRequest - 1;
        if (this.stateRequest == 0) {
          try {
            this.loading.dismiss();
          } catch (error) {}
        }
        if (resp.success) {
          me.data.total.active_fi = 0;
          me.data.instruction.active = [];
          me.data.instruction.last = [];
          resp.data.forEach(row => {
            if (row.flag == "current") {
              me.data.total.active_fi = me.data.total.active_fi + 1;
              me.data.instruction.active.push(row);
            }
            if (row.flag == "last") {
              me.data.instruction.last.push(row);
            }
          });
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  togleSegment(content, active) {
    if (content == active) {
      this.collapseSegment(null, content);
    } else {
      this.expandSegment(null, content);
    }
  }

  myDept(evt) {
    let me = this;
    this.showLoading();
    let params = {
      id: this.userApi.data.Employee_ID,
      active_tab: this.btnTabProfilActive
    };
    this.repositoryMyRadiant.getMyOrganization(params).subscribe(
      (resp: any) => {
        try {
          this.loading.dismiss();
        } catch (error) {}
        if (resp.success) {
          let departmentModal = this.modalCtrl.create(
            cmpMyOrganization,
            {
              karyawan: resp.data.list,
              isAddHoc: resp.data.isAddHoc,
              fiturSearching: true,
              title: "My Dept",
              level: resp.data.level
            },
            { cssClass: "select-modal", enableBackdropDismiss: false }
          );
          departmentModal.onDidDismiss(department => {
            if (department) {
              if (department == "me") {
                me.data.employee = "Me";
                me.parameter.nik = this.userApi.data.NIK;
                me.parameter.user_code = this.userApi.data.NIK;
                me.parameter.id = this.userApi.data.Employee_ID;
                me.parameter.flag = "team";
                if (me.btnTabProfilActive == "Asset") {
                  me.data.department_selected.fasker = "";
                } else if (me.btnTabProfilActive == "Advance") {
                  me.data.department_selected.advance = "";
                }
              } else {
                me.data.employee = department.TEXT;
                me.parameter.nik = department.department_id;
                me.parameter.user_code = department.department_id;
                // me.parameter.id = department.id;
                me.parameter.flag = "dept";
                if (me.btnTabProfilActive == "Asset") {
                  me.data.department_selected.fasker = department.TEXT;
                } else if (me.btnTabProfilActive == "Advance") {
                  me.data.department_selected.advance = department.TEXT;
                }
              }
              // this.showLoading();
              console.log(me.btnTabProfilActive);
              switch (me.btnTabProfilActive) {
                case "Asset":
                  me.getAssets();
                  break;
                case "Advance":
                  me.getAdvance();
                  break;
                default:
                  break;
              }
            }
          });
          departmentModal.present();
        }
      },
      err => {
        this.presentToast("Error");
        try {
          this.loading.dismiss();
        } catch (error) {}
      }
    );
  }

  showNotification() {
    this.nav.push(NotifikasiPage);
  }

  showFilterPerformance(){
    let me = this;
    let cmpFilter = this.modalCtrl.create(
      FilterProjectApps,
      { data: null, title: "Filter Performance Project", page: "detail_project_performance" },
      { cssClass: "select-modal", enableBackdropDismiss: false }
    );
    cmpFilter.present();
  }

  reportFasker(data) {
    let me = this;
    console.log(data);
    let element_content =
      `
      <div style="width:100%;padding: 1px 10px;" >
        <h5 class="text-biru" text-left style="font-size:15px;">
          ` +
      data.asset_name +
      `
        </h5>
        <p class="text-abu" style="margin-top:0px;font-size:14px;" text-left>` +
      data.asset_new_code +
      `</p>
      </div> 
      <div style="padding:10px">
        <textarea class="swal-content__textarea" rows="7" id="notes-report-fasker" placeholder="Enter Notes Here..">` +
      this.helper.ifvalnull(data.report_message, "") +
      `</textarea>
      </div> 
    `;
    let options = {
      title: "Report",
      content: element_content
    };
    let params = {
      report: "",
      asset_id: data.id,
      asset_name: data.asset_name,
      employee_name: me.userApi.data.Nama_Karyawan,
      code_rui: data.asset_new_code,
      location_id: data.asset_location_id,
      employee_id: me.userApi.data.employee_id,
      updated_at: data.updated_at
    };
    this.helper.presentSwalCustomContent(options, () => {
      params.report = document.getElementById("notes-report-fasker")["value"];
      me.faskerProvider.addReport(params).subscribe((resp: any) => {
        if (resp.success) {
          me.stateRequest = 1;
          me.loading = me.helper.showLoading("Loading data...");
          me.getAssets();
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/project-detail/page.ts